// extracted by mini-css-extract-plugin
var _1 = "edit-icon--QtCy6";
var _2 = "edit-subtitle-button--FWrq5";
var _3 = "header-actions--zkIOe";
var _4 = "header-actions-bar--hRD_b";
var _5 = "header-subtitle--ywvDq";
var _6 = "header-subtitle-container--jV70p";
var _7 = "header-title--uGpxQ";
var _8 = "page-header--KKU31";
export { _1 as "edit-icon", _2 as "edit-subtitle-button", _3 as "header-actions", _4 as "header-actions-bar", _5 as "header-subtitle", _6 as "header-subtitle-container", _7 as "header-title", _8 as "page-header" }
